<div class="container-fluid py-3">
  <div class="row">
    <div class="col-12">
      <p-table #dt
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        [filterDelay]="0"
        [loading]="guardService.loading"
        [paginator]="true"
        [rows]="10"
        [rowHover]="true"
        [rowsPerPageOptions]="[10, 25, 50]"
        [showCurrentPageReport]="true" 
        [value]="guardService.guards"
        pDroppable="row">
        
        <ng-template pTemplate="caption">
          <div class="container-fluid">
            <div class="row">
              <div class="col-4 d-flex align-items-center">
                Vigilantes
              </div>
              <div class="col-8 text-end">

                <div class="d-inline-block" ngbDropdown>
                  <button
                    type="button"
                    class="btn btn-success me-2"
                    ngbDropdownToggle>
                    Agregar
                  </button>
                  <div ngbDropdownMenu>
                    <button 
                      (click)="create()"
                      ngbDropdownItem>
                      Nuevo usuario
                    </button>
                    <button 
                      (click)="linkUser()"
                      ngbDropdownItem>
                      Vincular usuario
                    </button>
                  </div>
                </div>

                <button (click)="guardService.getAll(neighborhoodId!)" class="btn btn-primary rounded-circle me-2">
                  <i class="material-icons mt-1">refresh</i>
                </button>
              </div>
            </div>
          </div>
        </ng-template>

        <ng-template pTemplate="header">
          <tr>

            <th>
              Usuario
            </th>

            <th pSortableColumn="guard.fullName">
              Nombre
              <p-sortIcon field="guard.fullName"></p-sortIcon>
              <p-columnFilter type="text" field="guard.fullName" display="menu"></p-columnFilter>
            </th>

            <th pSortableColumn="gate.gateName">
              Acceso
              <p-sortIcon field="gate.gateName"></p-sortIcon>
              <p-columnFilter type="text" field="gate.gateName" display="menu"></p-columnFilter>
            </th>

            <th pSortableColumn="digitalLogModule">
              Bitácora digital
              <p-sortIcon field="digitalLogModule"></p-sortIcon>
              <p-columnFilter type="boolean" field="digitalLogModule" display="menu"></p-columnFilter>
            </th>

            <th pSortableColumn="bookingsModule">
              Reservas
              <p-sortIcon field="bookingsModule"></p-sortIcon>
              <p-columnFilter type="boolean" field="bookingsModule" display="menu"></p-columnFilter>
            </th>

            <th pSortableColumn="aiModuleVisits">
              Módulo de IA
              <p-sortIcon field="aiModuleVisits"></p-sortIcon>
              <p-columnFilter type="boolean" field="aiModuleVisits" display="menu"></p-columnFilter>
            </th>

            <th>Acciones</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-guard>
          <tr class="p-selectable-row">
            <td>
              <span class="p-column-title">Usuario</span>
              {{ guard.email != '' ? guard.email : guard.username }}
            </td>

            <td>
              <span class="p-column-title">Nombre</span>
              {{ guard.guard?.fullName }}
            </td>

            <td>
              <span class="p-column-title">Acceso</span>
              {{ guard.gate?.gateName ?? '-' }}
            </td>

            <td class="">
              <span class="p-column-title">Activo</span>
              <i 
                class="material-icons"
                [ngClass]="{
                  'text-success': guard.digitalLogModule,
                  'text-danger': !guard.digitalLogModule
                }">
                {{ guard.digitalLogModule ? 'check_circle' : 'cancel' }}
              </i>
            </td>

            <td class="">
              <span class="p-column-title">Reservas</span>
              <i 
                class="material-icons"
                [ngClass]="{
                  'text-success': guard.bookingsModule,
                  'text-danger': !guard.bookingsModule
                }">
                {{ guard.bookingsModule ? 'check_circle' : 'cancel' }}
              </i>
            </td>

            <td class="">
              <span class="p-column-title">Módulo de IA</span>
              <i
                class="material-icons"
                [ngClass]="{
                  'text-success': guard.aiModuleVisits,
                  'text-danger': !guard.aiModuleVisits
                }">
                {{ guard.aiModuleVisits ? 'check_circle' : 'cancel' }}
              </i>
            </td>

            <td>

              <!-- <button
                (click)="open(guard)"
                class="btn btn-sm btn-light rounded-circle me-2">
                <i class="material-icons mt-1">more_vert</i>
              </button>

              <button 
                (click)="delete(guard)"
                class="btn btn-sm btn-danger rounded-circle">
                <i class="material-icons mt-1">delete</i>
              </button> -->

              <div 
                ngbDropdown 
                class=""
                placement="left-top">
                <button 
                  type="button" 
                  class="btn btn-sm btn-light rounded-circle me-2 my-1"
                  [id]="guard.uidGuard" 
                  ngbDropdownToggle>
                  <span class="material-icons">
                    <small>more_vert</small>
                  </span>
                </button>
                <div 
                  ngbDropdownMenu>
                  @if(authService.currentUser?.profile === 'sudo') {
                    <!-- <button 
                      ngbDropdownItem
                      class="d-flex align-items-center"
                      (click)="openDevices(guard)">
                      <i class="material-icons text-secondary me-2">phone_iphone</i>
                      Dispositivos
                    </button> -->
                  }

                  <button 
                    ngbDropdownItem
                    class="d-flex align-items-center"
                    (click)="open(guard)">
                    <i class="material-icons text-secondary me-2">edit</i>
                    Editar
                  </button>

                  <button 
                    ngbDropdownItem
                    class="d-flex align-items-center"
                    (click)="restorePassword(guard)">
                    <i class="material-icons text-secondary me-2">refresh</i>
                    Restaurar contraseña
                  </button>

                  <div class="dropdown-divider"></div>

                  <button 
                    ngbDropdownItem
                    class="d-flex align-items-center text-danger"
                    (click)="delete(guard)">
                    <i class="material-icons me-2">delete</i>
                    Borrar
                  </button>

                </div>
              </div>

            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
